<div class="header">
    <div class="header-cont">
        <h2>{{ 'new_theme.title' | translate }}</h2>
    </div>
</div>

<div class="section-headers">
    <div class="section-headers-cont">
        <h4>{{ 'new_theme.sections.name' | translate }}</h4>
    </div>
</div>

<div class="single-section">
    <div class="section-cont">
        <mat-tab-group>
            <mat-tab label="Italiano">
                <mat-form-field class="section-input">
                    <mat-label>{{ 'new_theme.sections.name' | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="theme_current.name.it" required>
                </mat-form-field>
            </mat-tab>
            <mat-tab label="Slovenščina">
                <mat-form-field class="section-input">
                    <mat-label>{{ 'new_theme.sections.name' | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="theme_current.name.sl" required>
                </mat-form-field>
            </mat-tab>
            <mat-tab label="English">
                <mat-form-field class="section-input">
                    <mat-label>{{ 'new_theme.sections.name' | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="theme_current.name.en" required>
                </mat-form-field>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

<div class="page-footer">
    <div class="page-footer-btns">
        <button mat-raised-button class="save-icon-btn" (click)="saveTheme()" [disabled]="saveButtonDisabled()">
            <mat-icon>save</mat-icon>
        </button>
    </div>
</div>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
